import React from 'react';
import { Tab } from '@mui/material';
import { CountLabel, RecordTabs } from 'components/record-shell/RecordShell';

interface ProcedureTabProps {
  tab: string;
  onChange: (newTab: string) => void;
  counts: { doctors: number; specialties: number; packages: number; products: number };
}

const ProcedureTab: React.FC<ProcedureTabProps> = ({ tab, onChange, counts }) => {
  return (
    <RecordTabs tab={tab} onChange={onChange}>
      <Tab value="main" label="Geral" />
      <Tab value="doctors" label={<CountLabel label="Médicos" count={counts.doctors} />} />
      <Tab value="specialties" label={<CountLabel label="Especialidades" count={counts.specialties} />} />
      <Tab value="packages" label={<CountLabel label="Pacotes" count={counts.packages} />} />
      <Tab value="products" label={<CountLabel label="Produtos" count={counts.products} />} />
    </RecordTabs>
  );
};

export default ProcedureTab;
